import React from "react";
import PropTypes from "prop-types";
import { useIntl, FormattedMessage } from "react-intl";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography/Typography";
import { Box, Flex, Grid, GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { Form } from "@domestika-dev/prudencio/dist/atoms/Form";
import CollapsableCard from "../../../../common/CollapsableCard";
import NumberedList from "../../../../common/NumberedList";

export const LiveSetupStreamingKeysSetupCard = ({ liveChannel }) => {
  const intl = useIntl();

  const getCredentialsInputsContent = () => (
    <Box style={{ width: "100%" }} marginTop={4}>
      <Flex>
        <Grid style={{ width: "100%" }}>
          <GridItem gridRow="1">
            <Text
              size="nano"
              textAlign="left"
              color="guijarro"
              margin={0}
              style={{
                top: "8px",
                left: "16px",
                position: "absolute",
                zIndex: 9999,
              }}
            >
              <FormattedMessage id="live_sessions.streamlabs_setup.url" />
            </Text>
            <Form.Input
              size="medium"
              id="liveChannelIngestEndpoint"
              name="liveChannelIngestEndpoint"
              defaultValue={liveChannel.ingestEndpoint}
              style={{
                paddingTop: "24px",
                paddingbottom: "8px",
              }}
              readOnly
            />
          </GridItem>
        </Grid>
      </Flex>
      <Flex marginTop={4}>
        <Grid style={{ width: "100%" }}>
          <GridItem gridRow="1">
            <Text
              size="nano"
              textAlign="left"
              color="guijarro"
              margin={0}
              style={{
                top: "8px",
                left: "16px",
                position: "absolute",
                zIndex: 9999,
              }}
            >
              <FormattedMessage id="live_sessions.streamlabs_setup.transmission_key" />
            </Text>
            <Form.Input
              size="medium"
              id="liveChannelStreamKey"
              name="liveChannelStreamKey"
              defaultValue={liveChannel.streamKeyValue}
              style={{
                paddingTop: "24px",
                paddingBottom: "8px",
              }}
              readOnly
            />
          </GridItem>
        </Grid>
      </Flex>
    </Box>
  );

  return (
    <CollapsableCard
      headlineNumber={2}
      headlineText={intl.formatMessage({ id: "live_sessions.streamlabs_setup.step_2_title" })}
      headlineChildren={getCredentialsInputsContent()}
    >
      <Flex flexDirection="column">
        <NumberedList
          marginTop={4}
          items={[
            {
              headline: intl.formatMessage({
                id: "live_sessions.streamlabs_setup.step_2.open_streamlabs",
              }),
            },
            {
              headline: intl.formatMessage({
                id: "live_sessions.streamlabs_setup.step_2.streamlabs_settings",
              }),
              children: (
                <Text size="tiny" textAlign="left" paddingLeft={3} marginTop={4}>
                  <FormattedMessage id="live_sessions.streamlabs_setup.step_2.streamlabs_custom_streaming_server" />
                </Text>
              ),
            },
          ]}
        />
      </Flex>
    </CollapsableCard>
  );
};

LiveSetupStreamingKeysSetupCard.propTypes = {
  liveChannel: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    streamKeyValue: PropTypes.string,
    ingestEndpoint: PropTypes.string,
  }),
};

LiveSetupStreamingKeysSetupCard.defaultProps = {
  liveChannel: {},
};

export default LiveSetupStreamingKeysSetupCard;
